import { Link } from "react-location";

import './Slider.scss'

export const Slider = ({ sliderItems }) => (
  <section className="anchor-section slider">
    <h2 className="anchor--title">Mes autres projets</h2>
    <div className="anchor--separator" />

    <div className="slider-wrapper">
      {sliderItems.map((item) => {
        const { classSuffix, image, subtitle, title, url } = item

        return (
          <div className={`slider__item slider__item--${classSuffix}`} key={url}>
            <div className="slider__item-content">
              <div className="slider__item-texts">
                <h4 className="slider__item-title">{title}</h4>
                <p className="slider__item-subtitle">{subtitle}</p>

                <Link className="button" to={url}>
                  <div className="slider__button">
                      Voir le projet
                  </div>
                </Link>
              </div>

              <img alt="Logo projet" className="slider__item-image" src={image} />
            </div>
          </div>
        )
      })}
    </div>
  </section>
)

export default Slider